import { forwardRef, memo } from 'react'
import { View } from 'react-native'
import ChevronDown from '../../../../assets/icons/chevron-down.svg'
import BarButton from '../buttons/BarButton'

interface MenuButtonProps {
    children: string
    onPress: () => void
}

const Component = forwardRef<View, MenuButtonProps>(function MenuButton(
    { children, onPress },
    ref
) {
    return (
        <BarButton
            onPress={onPress}
            ref={ref}
            contentStyle={{ flexDirection: 'row-reverse' }}
            Icon={ChevronDown}
        >
            {children}
        </BarButton>
    )
})

export default memo(Component)
